import { Grid } from '@mui/material';
import React, { useEffect } from 'react';

import SupportComponentPage from '../../components/Help/SupportComponent';
import PrivacyPolicyComponent from '../../components/Help/PrivacyPolicyComponent';
import TermsOfService from '../../components/Help/TermsOfService';

export default function HelpPage() {
    const urlRef = window.location.pathname.split('/')[1];

    const pageTitle =
        urlRef === 'privacy'
            ? 'Privacy Policy'
            : urlRef === 'terms'
              ? 'Terms Of Service'
              : 'Support';

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Grid
            sx={{
                width: '100%',
                minHeight: 'calc(100vh - var(--app-prompt-banner-height, 0px))',
                display: 'flex',
                flexDirection: 'column',
                pb: 6, // ← Adds space at the bottom
            }}
        >
            <Grid sx={{ width: '100%' }}>
                {urlRef === 'support' ? (
                    <SupportComponentPage />
                ) : urlRef === 'privacy' ? (
                    <PrivacyPolicyComponent />
                ) : urlRef === 'terms' ? (
                    <TermsOfService />
                ) : null}
            </Grid>
        </Grid>
    );
}
